const HTTP_URL_REGEX =
  /^(https?):\/\/(?:(localhost)|((\d{1,3}\.){3}\d{1,3})|((?:[a-z\d](?:[a-z\d-]*[a-z\d])*\.)+[a-z]{2,}))(?::\d{2,5})?(?:[/?#][^\s]*)?$/i;

export function getValidHttpUrl(value?: string | null) {
  if (!value) return undefined;
  const trimmed = value.trim();
  return HTTP_URL_REGEX.test(trimmed) ? trimmed : undefined;
}
